export const SET_PLAYER_INVENTORY = 'SET_PLAYER_INVENTORY'
export const ADD_RANDOM_ITEM = 'ADD_RANDOM_ITEM'
export const DELETE_ITEM_FROM_INVENTORY = 'DELETE_ITEM_FROM_INVENTORY'